import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'em-tooltip-container',
    templateUrl: './tooltip-container.component.html',
    styleUrls: ['./tooltip-container.component.scss'],
    standalone: false
})
export class TooltipContainerComponent implements OnInit {

  readonly position = input<'top' | 'bottom' | 'left' | 'right'>('right');

  readonly closed = output<void>();

  visible: boolean = false;

  wrapperClass!: string;
  pointerClass!: string;

  ngOnInit(): void {
    const baseWrapperClass = ['absolute', 'z-50'];
    const basePointerClass = ['absolute', 'rotate-45', 'w-3', 'h-3', 'bg-white'];

    switch (this.position()) {
      case 'top':
        this.wrapperClass = baseWrapperClass.concat(['bottom-full', 'top-auto', 'left-1/2', '-translate-x-1/2']).join(' ');
        this.pointerClass = basePointerClass.concat(['left-1/2', 'translate-y-1/2', 'bottom-0']).join(' ');
        break;
      case 'bottom':
        this.wrapperClass = baseWrapperClass.concat(['top-full', 'bottom-auto', 'left-1/2', '-translate-x-1/2']).join(' ');
        this.pointerClass = basePointerClass.concat(['left-1/2', '-translate-y-1/2', 'top-0']).join(' ');
        break;
      case 'left':
        this.wrapperClass = baseWrapperClass.concat(['right-full', 'left-auto top-1/2', '-translate-y-1/2']).join(' ');
        this.pointerClass = basePointerClass.concat(['right-0', 'top-1/2', 'translate-x-1/2']).join(' ');
        break;
      case 'right':
        this.wrapperClass = baseWrapperClass.concat(['left-full', 'right-auto', 'top-1/2', '-translate-y-1/2']).join(' ');
        this.pointerClass = basePointerClass.concat(['left-0', 'top-1/2', '-translate-x-1/2']).join(' ');
        break;
    }
  }

  onClose(): void {
    if (this.visible) {
      this.closed.emit();
    } else {
      this.visible = true;
    }
  }

}
